import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EmployeeIdPipe } from '@coin/shared/auth/feature';
import { AuthComponentsModule } from '@coin/shared/auth/feature';
import { LegacyComponentsModule } from '@coin/shared/core/feature-legacy-components';
import {
  V2CardComponent,
  V2DialogModule,
  V2DualPillComponent,
  V2ButtonComponent
} from '@coin/shared/core/ui-storybook';
import { EnumToTextPipe, FormatUnknownValuePipe } from '@coin/shared/core/util-pipes';
import { TranslateModule } from '@ngx-translate/core';
import { SimplebarAngularModule } from 'simplebar-angular';
import { ActivityStreamComponent } from './activity-stream.component';
import { ActivityStreamDialogComponent } from './components/activity-stream-dialog/activity-stream-dialog.component';
import { ActivityStreamHeaderComponent } from './components/activity-stream-header/activity-stream-header.component';
import { ActivityStreamItemComponent } from './components/activity-stream-item/activity-stream-item.component';
import { ActivityStreamListComponent } from './components/activity-stream-list/activity-stream-list.component';
import { ActivityStreamMultipleItemsComponent } from './components/activity-stream-multiple-items/activity-stream-multiple-items.component';
import { ActivityStreamTagsComponent } from './components/activity-stream-tags/activity-stream-tags.component';
import { EllipsisTooltipDirective } from '@coin/shared/core/util-directives';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    LegacyComponentsModule,
    EnumToTextPipe,
    EmployeeIdPipe,
    MatIconModule,
    FormatUnknownValuePipe,
    SimplebarAngularModule,
    MatTooltipModule,
    AuthComponentsModule,
    V2DialogModule,
    V2DualPillComponent,
    ActivityStreamMultipleItemsComponent,
    V2CardComponent,
    EllipsisTooltipDirective,
    V2ButtonComponent
  ],
  declarations: [
    ActivityStreamComponent,
    ActivityStreamDialogComponent,
    ActivityStreamHeaderComponent,
    ActivityStreamItemComponent,
    ActivityStreamListComponent,
    ActivityStreamTagsComponent
  ],
  exports: [ActivityStreamComponent]
})
export class ActivityStreamModule {}
